// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createContext, useContext } from 'react';

interface NavigationContextType {
  activeSection: string | null;
  activeSubsection: string | null;
  setActiveSection: (section: string) => void;
  setActiveSubsection: (subsection: string) => void;
  setActiveSectionAndSubsection: (section: string, subsection: string) => void;
}

export const NavigationContext = createContext<
  NavigationContextType | undefined
>(undefined);

/**
 * Hook to access the navigation context
 */
export function useNavigationContext() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error(
      'useNavigationContext must be used within a NavigationProvider'
    );
  }
  return context;
}
